<!-- @format -->

<ng-container *transloco="let t">
  @if (studyEvent) {
    <sis-description-list-compact [columnCount]="twoColumns ? 2 : 1">
      <dl>
        <ng-template #compactListItem>
          <dt class="sis-label colon">{{ t("OPEN_UNIVERSITY.STUDY_EVENT_INFO.DATE") }}</dt>
          <dd class="sis-value">{{ studyEvent | studyEventWeekdayOrInterval }} {{ studyEvent | studyEventDateRange }}</dd>
        </ng-template>
        <ng-template #compactListItem>
          <dt class="sis-label colon">{{ t("OPEN_UNIVERSITY.STUDY_EVENT_INFO.TIME") }}</dt>
          <dd class="sis-value">{{ studyEvent | studyEventTimeRange }}</dd>
        </ng-template>
        <ng-template #compactListItem>
          <dt class="sis-label colon">{{ t("OPEN_UNIVERSITY.STUDY_EVENT_INFO.PLACE") }}</dt>
          @if (hasLocations(studyEvent)) {
            @for (location of studyEvent.locations; track location; let last = $last) {
              <dd class="sis-value">
                <ng-container *ngTemplateOutlet="locationDetails; context: { location: location, last: last }"></ng-container>
              </dd>
            }
          } @else {
            @for (locationId of studyEvent.locationIds; track locationId; let last = $last) {
              <dd class="sis-value">
                <ng-container
                  *ngTemplateOutlet="locationDetails; context: { location: locationId | location | async, last: last }"></ng-container>
              </dd>
            }
          }
        </ng-template>
        @if (teacherIds?.length > 0) {
          <ng-template #compactListItem>
            <dt class="sis-label colon">{{ t("COURSE_UNIT_REALISATION_INFO.TEACHER") }}</dt>
            @for (teacherId of teacherIds; track teacherId; let last = $last) {
              <dd class="sis-value">
                @if (teacherId | publicPerson | async; as teacher) {
                  {{ teacher | personFullName }}{{ last ? "" : "," }}
                }
              </dd>
            }
          </ng-template>
        }
        @if (studyEvent.cancellations?.length > 0) {
          <ng-template #compactListItem>
            <dt class="sis-label colon">{{ t("OPEN_UNIVERSITY.STUDY_EVENT_INFO.CANCELLED_EVENTS") }}</dt>
            <dd class="sis-value">{{ studyEvent.cancellations.length }}</dd>
          </ng-template>
        }
      </dl>
    </sis-description-list-compact>
  }
</ng-container>

<ng-template #locationDetails let-location="location" let-last="last">
  {{ location?.building?.name | localizedString }}, {{ location?.name | localizedString }}{{ last ? "" : ";" }}
</ng-template>
